import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { copy } from '../copy';
import { QUIT_BASE } from '../dashboardDefaults';
import { useLogCigarette } from '../hooks';
import { SCREEN } from '../styles';

/** Location keys already handled, so StrictMode's second effect run (and a re-render) never logs twice. */
const handled = new Set<string>();

/** Opened by the "+1 cigarette" app-icon shortcut (conventions §15, module deep links). */
export function ShortcutLogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const log = useLogCigarette();

  useEffect(() => {
    if (handled.has(location.key)) return;
    handled.add(location.key);
    const key = location.key;
    void log().then((ok) => {
      navigate(ok ? QUIT_BASE : `${QUIT_BASE}/plan`, { replace: true });
      // The route has replaced itself, so a later visit (a new launch) may log again.
      handled.delete(key);
    });
  }, [location.key, log, navigate]);

  return (
    <main className={SCREEN}>
      <p role="status" className="text-muted">
        {copy.logging}
      </p>
    </main>
  );
}
